<div class="reviews-outer">
  <h2 class="trinidad-bold">Sights and sounds at {{ (boondock$ | async)?.name }}.</h2>
  <p class="wizard-paragraph _12px">
    Caretakers provide information for the boondocking location. Caretakers can take control of any boondocking
    location.
  </p>
  <div class="form-block w-form">
    <form name="conditions" class="wizard-form" [formGroup]="conditionsForm">
      <h3 class="wizard-h3 _18px">What is the noise level that CurbNTurfers can expect at the site?</h3>
      <div class="button-wrapper-grid" formGroupName="noiseLevel">
        <curbnturf-toggle-button
          label="Silence"
          formControlName="silence"
          (selectChange)="onSelectNoiseLevel('silence')"
        >
        </curbnturf-toggle-button>
        <curbnturf-toggle-button
          label="Sounds of Nature"
          formControlName="nature"
          (selectChange)="onSelectNoiseLevel('nature')"
        >
        </curbnturf-toggle-button>
        <curbnturf-toggle-button
          label="Periodic Sounds"
          formControlName="periodic"
          (selectChange)="onSelectNoiseLevel('periodic')"
        >
        </curbnturf-toggle-button>
        <curbnturf-toggle-button
          label="Constant Noise"
          formControlName="constant"
          (selectChange)="onSelectNoiseLevel('constant')"
        >
        </curbnturf-toggle-button>
      </div>
      <h3 class="wizard-h3 _18px">What are the road conditions to the site?</h3>
      <div>(Select all that apply)</div>
      <div class="button-wrapper-grid" formGroupName="road">
        <curbnturf-toggle-button label="Paved" formControlName="paved" (selectChange)="onSelectRoadCondition('paved')">
        </curbnturf-toggle-button>
        <curbnturf-toggle-button
          label="Smooth Gravel"
          formControlName="smoothGravel"
          (selectChange)="onSelectRoadCondition('smoothGravel')"
        >
        </curbnturf-toggle-button>
        <curbnturf-toggle-button
          label="Poor Gravel"
          formControlName="poorGravel"
          (selectChange)="onSelectRoadCondition('poorGravel')"
        >
        </curbnturf-toggle-button>
        <curbnturf-toggle-button
          label="High Clearance"
          formControlName="highClearance"
          (selectChange)="onSelectRoadCondition('highClearance')"
        >
        </curbnturf-toggle-button>
        <curbnturf-toggle-button
          label="Off-Road Path"
          formControlName="offRoad"
          (selectChange)="onSelectRoadCondition('offRoad')"
        >
        </curbnturf-toggle-button>
      </div>
      <div class="toggle-wrapper _18px">
        <div>
          <label for="hazards">
            <strong class="semi-bold-2"> Are there known potential hazards? </strong>
          </label>
        </div>
        <label>
          <ion-toggle
            color="dark"
            id="hazards"
            formControlName="hazards"
            [value]="true"
            [checked]="conditionsForm.get('hazards')?.value"
            aria-label="Hazards"
          >
          </ion-toggle>
        </label>
      </div>
      <textarea
        class="width100"
        *ngIf="conditionsForm.get('hazards')?.value === true"
        formControlName="hazardDescription"
        rows="3"
        placeholder="Please describe the potential hazards..."
      ></textarea>
      <h3 class="wizard-h3 _18px">What is the size of the boondocking size?</h3>
      <curbnturf-rating-incremental label="Bus(es)" formControlName="buses"> </curbnturf-rating-incremental>
      <div>How many buses could fit in the space?</div>
      <curbnturf-rating-incremental label="Car(s)" formControlName="cars"> </curbnturf-rating-incremental>
      <div>How many cars could fit in the space?</div>
      <div class="horz-line"></div>
      <div class="toggle-wrapper _18px">
        <div>
          <label for="wheelchair">
            <strong class="semi-bold"> Is the site wheelchair accessible? </strong>
          </label>
        </div>
        <ion-toggle
          color="dark"
          id="wheelchair"
          formControlName="wheelchair"
          [value]="true"
          [checked]="conditionsForm.get('wheelchair')?.value"
          aria-label="Wheelchair Accessible"
        >
        </ion-toggle>
      </div>
      <div class="button-wrapper">
        <a role="button" class="button trinidad center w-button" (click)="onContinue()"> Continue </a>
      </div>
      <div class="skip" *ngIf="!appContext">
        <a role="button" (click)="onSkip()">Skip</a>
      </div>
    </form>
  </div>
</div>
